import routeMixin from '@/router/routeMixin'
import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import _ from 'lodash'
import SuiviCAModel from './models/SuiviCAModel'

export default mixins(routeMixin, globalMixin).extend({
    data: function() {
        return {
            datasGlobales: null as null | SuiviCAModel[],
            suiviCA: null as null | SuiviCAModel,
            companyName: '',
            drName: null as string | null,
            commercialName: null as string | null,
            businessUnit: null as string | null,
            dateDebut: new Date().getFullYear() + '-01-01',
            dateFin: new Date().getFullYear() + '-' + ('00' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('00' + new Date().getDate()).slice(-2)
        }
    },
    methods: {
        onDateChange() {
            if (this.companyName) {
                this.onCompanyChange()
            } else {
                this.loadSuiviCAGlobal()
            }
        },
        onCompanyChange() {
            if (!this.companyName) {
                this.suiviCA = null
            } else {
                this.suiviCA = new SuiviCAModel()
                this.loadSuiviCA(this.companyName, this.suiviCA)
            }
        },
        loadSuiviCA(companyName: string, model: SuiviCAModel) {
            this.$loader.go()
            this.$http
                .api(`suiviCA`)
                .post({
                    entreprise: companyName,
                    dateDebut: this.dateDebut,
                    dateFin: this.dateFin
                })
                .then(x => {
                    model.feed(x.data)
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadSuiviCAGlobal() {
            this.$loader.go()
            this.$http
                .api(`suiviCA/all`)
                .post({
                    dateDebut: this.dateDebut,
                    dateFin: this.dateFin
                })
                .then(x => {
                    this.datasGlobales = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        chiffreAffaireEvolution(suiviCA: SuiviCAModel) {
            return suiviCA.ytD_N1 != 0 ? (suiviCA.ytD_N * 100) / suiviCA.ytD_N1 - 100 : 0
        },
        chiffreAffaireDiff(suiviCA: SuiviCAModel) {
            return suiviCA.ytD_N - suiviCA.ytD_N1
        }
    },
    computed: {
        allCommerciaux(): string[] {
            if (!this.datasGlobales)
                return []

            const result = _.chain(this.datasGlobales)
                .filter(this.businessUnit ? data => data.businessUnit == this.businessUnit : () => true)
                .filter(this.drName ? data => data.dr == this.drName : () => true)
                .map((data): string => data.commercial || '')
                .filter(a => a !== '')
                .value()

            return result
        },
        allBusinessUnits(): string[] {
            if (!this.datasGlobales)
                return []

            return _.chain(this.datasGlobales).uniqBy(data => data.businessUnit).map(x => x.businessUnit).filter(x => x !== null).value()
        },
        allDR(): string[] {
            if (!this.datasGlobales)
                return []

            let datas = _.chain(this.datasGlobales)
            if (this.businessUnit)
                datas = datas.filter(data => data.businessUnit == this.businessUnit)

            return datas
                .map((data): string => data.dr || '')
                .filter(a => a !== '')
                .value()
        },
        allCompanies(): { text: string; value: string }[] {
            if (!this.datasGlobales)
                return []

            const companies = _.chain(this.datasGlobales)

            const companiesFiltered = this.commercialName ?
                companies.filter(data => data.commercial == this.commercialName) :
                this.drName ?
                    companies.filter(data => data.dr == this.drName) :
                    this.businessUnit ?
                        companies.filter(data => data.businessUnit == this.businessUnit) :
                        companies

            const codeClients = companiesFiltered
                .filter(a => a.client != null)
                .map(data => data.client as string[])
                .flatten()
                .value()

            return _.filter(this.companiesAutoComplete, data => codeClients.indexOf(data.value) != -1)
        },
        resultDRCommercial(): SuiviCAModel | undefined | null {
            if (this.suiviCA)
                return this.suiviCA

            if (!this.datasGlobales)
                return null

            let data = this.datasGlobales

            if (this.commercialName) {
                data = _.filter(this.datasGlobales, data => data.commercial == this.commercialName)
            } else if (this.drName) {
                data = _.filter(this.datasGlobales, data => data.dr == this.drName)
            } else if (this.businessUnit) {
                data = _.filter(this.datasGlobales, data => data.businessUnit == this.businessUnit)
            }

            return data.reduce((previous, current) => {
                const res = new SuiviCAModel()

                res.n = current.n
                res.n1 = current.n1
                res.n2 = current.n2
                res.chiffreAffaireAnneeN = previous.chiffreAffaireAnneeN + current.chiffreAffaireAnneeN
                res.chiffreAffaireAnneeN1 = previous.chiffreAffaireAnneeN1 + current.chiffreAffaireAnneeN1
                res.chiffreAffaireAnneeN2 = previous.chiffreAffaireAnneeN2 + current.chiffreAffaireAnneeN2
                res.ytD_N = previous.ytD_N + current.ytD_N
                res.ytD_N1 = previous.ytD_N1 + current.ytD_N1

                return res
            })
        }
    },
    mounted: function() {
        this.loadSuiviCAGlobal()
    }
})
